import { z } from "zod";

export const DadosCadSchemaValidate = z.object({
  email: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  phone: z
    .string()
    .min(11, { message: "Telefone inválido" })
    .refine((value) => value.trim() !== "", {
      message: "Campo obrigatório",
    }),
  nationality: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  maritalStatus: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  job: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  councilType: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  councilNumber: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
});
